import { render, staticRenderFns } from "./FooterComponentAmseu.vue?vue&type=template&id=560f61eb&scoped=true"
import script from "./FooterComponentAmseu.vue?vue&type=script&lang=ts"
export * from "./FooterComponentAmseu.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentAmseu.vue?vue&type=style&index=0&id=560f61eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f61eb",
  null
  
)

export default component.exports